export abstract class LanguageService {
    readonly SUPPORTED_LANGUAGES: string[] = ['fr', 'de', 'nl'];

    public abstract getLanguage(defaultLanguage: string): string;
}
